import { FieldInputProps, useField } from "formik";
import React, { useEffect, useRef } from "react";

import { BasicSinglelineTextInput } from "@gaming/xds-react-js";

import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldStateProps } from "../FieldHeader";
import { useSetFieldTouched } from "../useSetFieldTouched";

export type BasicInputProps = Readonly<{
  name: string;
  maxLength?: number;
  type?: "number" | "string";
  parentChecked?: boolean;
  customInputClass?: string;
  isRequired?: boolean;
  placeholder?: string;
  ariaLabel?: string;
  // eslint-disable-next-line
  customOnBlur?: (e: React.ChangeEvent<HTMLInputElement>, field: FieldInputProps<any>) => void;
  // eslint-disable-next-line
  customOnChange?: (e: React.ChangeEvent<HTMLInputElement>, field: FieldInputProps<any>) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (_event: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFocus?: (_event: any) => void;
}> &
  FieldStateProps;

export const BasicInput = (props: BasicInputProps) => {
  const [field] = useField(props);
  useSetFieldTouched(field.name);
  const textInputRef = useRef<HTMLDivElement>();

  const { type, maxLength, customInputClass, isRequired, customOnBlur, customOnChange } = props;

  useEffect(() => {
    if (textInputRef?.current) {
      const inputWrapper = document.getElementById(field.name)?.parentElement;
      if (inputWrapper) {
        inputWrapper.removeAttribute("role");
        inputWrapper.removeAttribute("tabindex");
      }
    }
  }, [textInputRef, field]);

  return (
    <BasicSinglelineTextInput
      aria-required="true"
      checked={field.checked}
      className={commonStyles.textField}
      data-testid={field.name}
      disabled={props.isSaving || props.parentChecked === false}
      id={field.name}
      inputClassName={customInputClass ? customInputClass : commonStyles.textFieldText}
      maxLength={maxLength}
      multiple={field.multiple}
      name={field.name}
      onBlur={customOnBlur ? e => customOnBlur(e, field) : field.onBlur}
      onChange={customOnChange ? e => customOnChange(e, field) : field.onChange}
      onClick={props.onClick}
      onFocus={props.onFocus}
      ref={textInputRef}
      type={type}
      value={field.value ?? ""}
      required={isRequired}
      placeholder={props.placeholder}
      aria-label={props.ariaLabel}
    />
  );
};
